import React from "react";

import { AccountTable } from "@components/Screen/AccountTable";
import { url_reverse } from "@components/Utils";

export default function Accounts({ gameId, header }) {
    const apiUrl = url_reverse("api:game:account:list", { game_id: gameId });
    return <AccountTable apiUrl={apiUrl} header={header} />;
}
